import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { POPOVER_ANIMATION_DURATION, Popover, PopoverType, usePopoverHandlers } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { EventEnum } from '@as-react/common-types';
import { EventUtil } from '@as-react/common-utils';
import { RulerIcon } from '@yonderland/andes-icons';
import { Box, Icon, LinkButton } from '@yonderland/andes-react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { analyticsActions } from '../../../redux/analytics/actions/AnalyticsActions.creators';
import { productActions } from '../../../redux/product/actions/ProductActions';
import { makeGetSizeGuideData } from '../../../redux/product/selectors/ProductSelector';
import { generateTestId } from '../../../util/TestUtil';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
const TEST_ID = 'size-guide';
export const SizeGuideAlpha = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { pdpTemplateName } = useAemConfig();
    const { sizeGuideContent, sizeGuideContentUrl } = useSelector(makeGetSizeGuideData());
    const dispatch = useDispatch();
    const isPopup = Boolean(sizeGuideContent);
    const [isOpen, setIsOpen] = useState(false);
    const { anchorEl, handlePopoverOpen, handlePopoverClose } = usePopoverHandlers({
        close: () => setIsOpen(false),
    });
    const handleSizeGuideOpen = () => {
        dispatch(productActions.sizeGuideOpen());
        dispatch(analyticsActions.productDetailSizeGuideClick(pdpTemplateName));
        if (isPopup) {
            setIsOpen(true);
        }
        else {
            window.open(sizeGuideContentUrl, '_blank');
        }
    };
    useEffect(() => {
        if (isOpen) {
            handlePopoverOpen(null, null, true);
            setTimeout(() => EventUtil.dispatch(EventEnum.SIZE_GUIDE_POPOVER_OPEN), POPOVER_ANIMATION_DURATION);
        }
    }, [isOpen]);
    if (!sizeGuideContent && !sizeGuideContentUrl) {
        return null;
    }
    return (_jsxs(Box, { testId: TEST_ID, children: [_jsxs(LinkButton, { onClick: handleSizeGuideOpen, testId: generateTestId({ testId: TEST_ID, suffix: 'link' }), children: [_jsx(Icon, { source: RulerIcon, size: "xs" }), t('product.size.guide.link')] }), isPopup && (_jsx(Popover, { anchorEl: anchorEl, type: PopoverType.MODAL, onClose: handlePopoverClose, title: t('product.size.guide.link'), dataQA: generateTestId({ testId: TEST_ID, suffix: 'popup' }), children: _jsx(HtmlInclude, { htmlFragment: sizeGuideContent }) }))] }));
};
